import { deserialize, fetchWrapper } from '../fetch';
import type { User } from '../interface';

export const SESSION_TIMEOUT_LIMIT = 30_000; // 30 seconds

export const current = async (): Promise<User> => {
  const url = new URL('/app/v1/session', API_BASE_URL);
  return deserialize(
    await fetchWrapper(
      url.href,
      { method: 'GET', credentials: 'include' },
      SESSION_TIMEOUT_LIMIT
    )
  );
};

export const requestLogin = async (data: {
  tenantId: string;
}): Promise<{ url: string; message: string }> => {
  const url = new URL('/app/login', API_BASE_URL);
  url.searchParams.set('tenant', data.tenantId);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const requestNewToken = async (data: {
  authCode: string | null;
  state: string | null;
}): Promise<void> => {
  const url = new URL('/app/token', API_BASE_URL);
  if (data.authCode) {
    url.searchParams.set('authCode', data.authCode);
  }
  if (data.state) {
    url.searchParams.set('state', data.state);
  }
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const requestLogout = async (): Promise<{
  url: string;
  message: string;
}> => {
  const url = new URL('/app/logout', API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const ws = (): WebSocket => {
  return new WebSocket(new URL('/app/v1/ws', API_BASE_URL).href);
};

export const version = async (): Promise<{ version: string }> => {
  const url = new URL('/version.json', API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
